<form>
    <div class="select-method">
        <mat-form-field class="select-method-list">
            <mat-select
                placeholder="{{ 'SLIICER_TABLE.SLICER_SUMMARY.SELECT_BASIN_INFILTRATION' | translate }}"
                [ngModel]="state.method"
                [ngModelOptions]="{ standalone: true }"
                (selectionChange)="onSelectMethodChange($event.value)"
                [disabled]="isStudyLocked"
            >
                <mat-option *ngFor="let option of wasteWaterMethodOptions; trackBy: trackByIndex" [value]="option">
                    {{ wasteWaterMethodNames[option] | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field
            *ngIf="state.method !== BaseInfiltrationMethod.StevensSchutzbach && state.method !== BaseInfiltrationMethod.Mitchell"
            class="constant"
            >
            <input
                matInput
                placeholder="{{ 'SLIICER_TABLE.SLICER_SUMMARY.WASTEWATER_CONSTANT' | translate }}"
                type="number"
                [ngModel]="state.constant"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onConstantChange($event)"
                [disabled]="isStudyLocked"
                #wasteWaterConstant="ngModel"
                [pattern]="isPositiveInteger"
            />
            <span matSuffix>%</span>
        </mat-form-field>
        <div class="customMessage" *ngIf="showErrorMessage && state.method!='StevensSchutzbach'">
            <span class="mat-error">{{
                'CUSTOMER_EDITOR.RAIN_PROFILE.DRY_DAY.INTEGER_VALIDATION_ERROR' | translate
            }}</span>
        </div>
    </div>
    <div class="select-calculation-type-container">
        <mat-form-field class="select-calculation-type">
            <mat-select
                placeholder="{{ 'SLIICER_TABLE.SLICER_SUMMARY.SELECT_INFILTRATION_CALC_OPTION' | translate }}"
                [ngModel]="state.infiltrationType"
                [ngModelOptions]="{ standalone: true }"
                (selectionChange)="onSelectCalcOptionChange($event.value)"
                [disabled]="isStudyLocked"
                matTooltip="{{ getInfiltrationTypeTooltip(state.infiltrationType) }}"
                matTooltipPosition="above"
            >
                <mat-option *ngFor="let option of wasteWaterInflitrationCalculationOptions; trackBy: trackByIndex" [value]="option">
                    {{ wasteWaterInflitrationCalculationNames[option] | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <p class="method-desc">
        {{ wasteWaterMethodDescriptions[state.method] | translate}}
    </p>
</form>
